/**
 * 2.0 wave 2, Part 2 Train (spec-2.0-build-wave2.md 4.4d and 4.6 A1): the one place the Train paths live.
 *
 * With `train_2_0_v1` off, `/plan` is the season plan, exactly as it has always been. With it on, `/plan`
 * opens This week and the season page moves one level down to `/plan/season`. Every link that means "the
 * season plan" (Today's Next steps card, the race card arrow, the Train season link) reads the target through
 * `useSeasonPath()`, so the links agree on both sides of the flag and flag off changes nothing.
 */
import { useServerFlag } from '../../hooks/useServerFlag';

/** The Train tab root: the legacy season plan with the flag off, This week with it on. */
export const THIS_WEEK_PATH = '/plan';

/** The season page one level down, in effect only with `train_2_0_v1` on. */
export const SEASON_PATH_V2 = '/plan/season';

/** One week's page (`routes/plan-week.tsx`). */
export function weekPath(n: number): string {
  return `/plan/week/${n}`;
}

/**
 * Where "the season plan" lives right now: `/plan` with `train_2_0_v1` off (wave 1 behavior, unchanged),
 * `/plan/season` with it on. The flag id is a string literal so the export rake can see this read.
 * Call it above every early return.
 */
export function useSeasonPath(): string {
  const trainV2 = useServerFlag('train_2_0_v1');
  return trainV2 ? SEASON_PATH_V2 : THIS_WEEK_PATH;
}
